import { Mic, Loader2 } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { useVoice } from "@/contexts/VoiceAssistantContext";

/** Dictar por voz (Whisper) → rellena el texto del chat. */
export const DictateButton = ({ onText }) => {
  const v = useVoice();
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (v.listening) { v.stopListening(); return; }
    setBusy(true);
    try {
      const r = await v.listen();
      if (r.error) toast.error(r.error);
      else if (!r.text) toast.message("No escuché nada");
      else onText(r.text);
    } finally { setBusy(false); }
  };
  return (
    <button type="button" data-testid="user-chat-dictate-btn" onClick={go} disabled={busy && !v.listening} title="Dictar con tu voz"
      className={`h-9 w-9 rounded-full border flex items-center justify-center transition ${v.listening ? "bg-red-500 border-red-400 text-white animate-pulse" : "bg-black/40 border-white/10 text-neutral-300 hover:text-[#d4af37] hover:border-[#d4af37]/50"}`}>
      {busy && !v.listening ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mic className="w-4 h-4" />}
    </button>
  );
};

export default DictateButton;
